import { render, staticRenderFns } from "./SubmerchantsPerformanceList.vue?vue&type=template&id=640acebf&"
import script from "./SubmerchantsPerformanceList.vue?vue&type=script&lang=js&"
export * from "./SubmerchantsPerformanceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports